import { useProfile } from '../context/ProfileContext';
import { translate } from './strings';

export function useT() {
  const { language } = useProfile();
  const lang = language || 'de';
  const t = (key, vars) => translate(lang, key, vars);
  return { t, lang };
}
